import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ReactComponent as WhiteLiliLogo } from '../../../../assets/icons/svg/icon-new-lili-logo-white.svg';
import { ReactComponent as BlueLiliLogo } from '../../../../assets/icons/svg/icon-new-lili-logo.svg';
import { VendorDetailsRequestFormSuccess } from './components/VendorDetailsRequestFormSuccess';
import { VendorDetailsRequestFormFailure } from './components/VendorDetailsRequestFormFailure';
import { VendorDetailsRequestFormInput } from './components/VendorDetailsRequestFormInput';
import { useStore } from '../../../../store';

interface VendorDetailsRequestFormProps {
  businessName: string;
}

export const VendorDetailsRequestForm = ({
  businessName,
}: VendorDetailsRequestFormProps) => {
  enum FormState {
    FORM,
    SUCCESS,
    ERROR,
  }

  const [formState, setFormState] = useState<FormState>(FormState.FORM);
  const isMobileScreen = useStore((state) => state.isMobileScreen);
  const onSuccess = () => {
    mixpanel.track('View Ask Vendor - Vendor view Success Screen', {
      'Flow end screen status': 'Success',
    });
    setFormState(FormState.SUCCESS);
  };
  return (
    <div
      className={`flex flex-col w-full h-[100dvh] items-center bg-bw01   max-w-[588px]  overflow-hidden ${isMobileScreen ? '' : 'max-h-[640px] shadow-md rounded-md'}`}
    >
      <div
        className={`flex flex-col  w-full items-center mt-[24px] py-[18px] ${!isMobileScreen && 'bg-action03'}`}
      >
        {isMobileScreen ? (
          <BlueLiliLogo className='w-[66px] h-[40px]' />
        ) : (
          <WhiteLiliLogo className='w-[66px] h-[40px]' />
        )}
      </div>
      <div className='h-full w-full'>
        <div className='h-full w-full'>
          {formState === FormState.FORM && (
            <VendorDetailsRequestFormInput
              onSuccess={onSuccess}
              onError={() => setFormState(FormState.ERROR)}
              businessName={businessName}
            />
          )}
          {formState === FormState.SUCCESS && (
            <VendorDetailsRequestFormSuccess />
          )}
          {formState === FormState.ERROR && (
            <VendorDetailsRequestFormFailure businessName={businessName} />
          )}
        </div>
      </div>
    </div>
  );
};
